var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-quantity"},[_c('div',{staticClass:"common",class:_vm.item.en},[_vm._v(_vm._s(_vm.item.chn))]),_c('div',{staticClass:"quantity"},[_vm._v(_vm._s(_vm._f("qianfen")(_vm.item.num)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }